// 全局配置文件
let HOST = ''
// let kkFileUrl = 'http://oadev.5dip.com/kkfile/onlinePreview?url='  //kkFileUrl文件预览   打包前需更改
// let kkFileUrl = 'https://oaadmin.5dip.com/kkfile/onlinePreview?url='  //kkFileUrl文件预览   打包前需更改
let kkFileUrl = 'https://oa.bjmzgyzgs.com/kkfile/onlinePreview?url='  //kkFileUrl文件预览   打包前需更改
// let kkFileUrl = this.$APPID  //kkFileUrl文件预览   打包前需更改
let fileUrlHOST = 'http://192.168.15.242:8889/' //文件下载地址 === 接口前缀

// let LARGEDATA = 'http://oadev.5dip.com/admin/' // dev
// let LARGEDATA = 'https://oaadmin.5dip.com/admin/' // admin
let LARGEDATA = 'https://oa.bjmzgyzgs.com/admin/'  //彩智正式

if (process.env.NODE_ENV === 'production') {
  // 正式环境
  // HOST = 'http://oadev.5dip.com/admin/'   // dev
  // HOST = 'https://oaadmin.5dip.com/admin/'  // admin
  HOST = 'https://oa.bjmzgyzgs.com/admin/' // 彩智正式
  fileUrlHOST = HOST
} else {
  // 测试环境
  HOST = '/api/'
  // fileUrlHOST = 'http://oadev.5dip.com/admin/'   //  dev
  fileUrlHOST = 'https://oaadmin.5dip.com/admin/'   //  admin
  // fileUrlHOST = 'https://oa.bjmzgyzgs.com/admin/'   // 彩智正式
}

module.exports = {
  HOST,
  fileUrlHOST,
  kkFileUrl,
  LARGEDATA
}



// WEBPACK FOOTER //
// ./src/http/config.js